export default __webpack_public_path__ + "static/media/51.714916d4.png";